var swiper = new Swiper(".mySwiper", {
    keyboard: {
        enabled: true,
    },  
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        enabled: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    grabCursor: true,
    breakpoints: {
        620: {
            navigation: {
                enabled: true,
            },
        },
    },
});


gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray("mark").forEach((mark) => {
    ScrollTrigger.create({
        trigger: mark,
        start: "top 75%",
        //toggleClass: "active",
        onEnter: () => mark.classList.add("active")
        //markers: true
    })
});

// Case study card animations
gsap.utils.toArray(".card.casestudy").forEach((card, index) => {
    const cardBody = card.querySelector(".card-body");
    const cardMedia = card.querySelector(".card-media");
    const tagItems = card.querySelectorAll(".tags ul li");
    const outcomeItems = card.querySelectorAll(".outcome-callouts ul li");
    const button = card.querySelector(".button, .accent-button");

    // Whole card entrance animation (skip first card)
    if (index > 0) {
        gsap.fromTo(card,
            {
                opacity: 0,
                y: 20
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.53,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: card,
                    start: "top bottom-=26%",
                    once: true,
                    //markers: true
                }
            }
        );
    }

    // Parallax animation timeline
    const parallaxTl = gsap.timeline({
        scrollTrigger: {
            trigger: card,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            //markers: true
        }
    });

    // Animate card body with more movement (faster parallax) - DRAMATIC FOR TESTING
    parallaxTl.fromTo(cardBody,
        { y: 50 },
        { y: -50, ease: "none" },
        0
    );

    // Animate card media with less movement (slower parallax) - DRAMATIC FOR TESTING
    parallaxTl.fromTo(cardMedia,
        { y: 25 },
        { y: -25, ease: "none" },
        0
    );

    // Fade-in animations - separate ScrollTrigger
    ScrollTrigger.create({
        trigger: card,
        start: "top 60%",
        onEnter: () => {
            // Animate tags with stagger
            if (tagItems.length > 0) {
                gsap.fromTo(tagItems,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 0.4,
                        stagger: 0.07,
                        ease: "power2.out"
                    }
                );
            }

            // Animate outcome callouts with stagger (slight delay after tags)
            if (outcomeItems.length > 0) {
                gsap.fromTo(outcomeItems,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 0.4,
                        stagger: 0.1,
                        delay: 0.13,
                        ease: "power2.out"
                    }
                );
            }

            // Animate button with upward motion (delay after other elements)
            if (button) {
                gsap.fromTo(button,
                    { opacity: 0, y: 20 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.53,
                        delay: 0.27,
                        ease: "power2.out"
                    }
                );
            }
        }
    });
});

// Hero iPhone layers floating parallax effect
gsap.fromTo("#upperRightHero, #heroPlay", 
    { y: 150 }, // Start 150px lower than original position (moved up from 200px)
    { 
        y: -350, // End 350px higher than original position (increased from -200px)
        ease: "none",
        scrollTrigger: {
            trigger: "body",
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            //markers: true
        }
    }
);

///Navbar animation
const showNav = gsap.from('#navbar', {
    yPercent: -200,
    paused: true,
    duration: 0.3
}).progress(1);

ScrollTrigger.create({
    start: "top top",
    end: "max",
    //markers: true,
    onUpdate: (self) => {
      self.direction === -1 ? showNav.play() : showNav.reverse()
    }
});

// Case Study Section Animations
if (document.body.id === 'casestudy-page') {
    gsap.utils.toArray("#casestudy-page section:not(.hero-cs)").forEach((section) => {
        // Get all direct children of the section (the content containers)
        const content = section.children;

        gsap.fromTo(content,
            {
                opacity: 0,
                y: 40
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: section,
                    start: "top bottom-=26%",
                    once: true,
                    //markers: true
                }
            }
        );
    });
}

// Sticky Notes Animation
const stickyNotes = document.querySelector('.sticky-notes');
if (stickyNotes) {
    const stickies = gsap.utils.toArray('.sticky');

    stickies.forEach((sticky, index) => {
        // Get the CSS rotation value
        const cssRotation = window.getComputedStyle(sticky).transform;
        const matrix = new DOMMatrix(cssRotation);
        const cssRotationDeg = Math.atan2(matrix.b, matrix.a) * (180 / Math.PI);

        gsap.fromTo(sticky,
            {
                opacity: 0,
                y: 40,
                scale: 1.1,
                rotation: gsap.utils.random(-15, 15)
            },
            {
                opacity: 1,
                y: 0,
                scale: 1,
                rotation: cssRotationDeg,
                duration: 0.6,
                delay: index * 0.15,
                ease: "back.out(1.2)",
                scrollTrigger: {
                    trigger: stickyNotes,
                    start: "top bottom-=26%",
                    once: true,
                    //markers: true
                }
            }
        );
    });
}

// Animated Quote Typing Effect
const animatedQuote = document.querySelector('.animated-quote');
if (animatedQuote && typeof SplitText !== 'undefined') {
    const blockquote = animatedQuote.querySelector('blockquote');
    const cite = animatedQuote.querySelector('.cite');

    // Split the blockquote text into characters, preserving words
    const split = new SplitText(blockquote, { type: "chars,words" });

    // Initially hide quote marks
    gsap.set(blockquote, {
        "--before-opacity": 0,
        "--after-opacity": 0
    });

    // Create timeline for the typing animation
    const typingTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: animatedQuote,
            start: "top bottom-=26%",
            once: true,
            //markers: true
        }
    });

    // Animate opening quote mark
    typingTimeline.to(blockquote, {
        "--before-opacity": 1,
        duration: 0.3,
        ease: "power2.out"
    });

    // Animate each character appearing with longer fade duration for softer effect
    typingTimeline.from(split.chars, {
        opacity: 0,
        duration: 1,
        stagger: 0.01,
        ease: "power2.out"
    }, "-=0.15");

    // Animate closing quote mark
    typingTimeline.to(blockquote, {
        "--after-opacity": 1,
        duration: 1.2,
        ease: "power2.out"
    }, "-=1.2");

    // Fade in the citation after the quote is done
    typingTimeline.from(cite, {
        opacity: 0,
        duration: 2.5,
        ease: "power2.out"
    }, "-=0.7");
}

// Callout Section Animation (App Design Case Study)
const calloutAnimated = document.querySelector('.callout-animated');
if (calloutAnimated) {
    const calloutSetup = calloutAnimated.querySelector('.callout-setup');
    const calloutPunch1 = calloutAnimated.querySelector('.callout-punch1');
    const calloutPunch2 = calloutAnimated.querySelector('.callout-punch2');

    const calloutTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: calloutAnimated,
            start: "top bottom-=26%",
            once: true,
            //markers: true
        }
    });

    // Animate setup line from right
    calloutTimeline.from(calloutSetup, {
        opacity: 0,
        x: 20,
        duration: 0.8,
        ease: "power2.out"
    });

    // Animate punch line 1 from left
    calloutTimeline.from(calloutPunch1, {
        opacity: 0,
        x: -20,
        duration: 0.8,
        ease: "power2.out"
    }, "-=0.4");

    // Animate punch line 2 from right
    calloutTimeline.from(calloutPunch2, {
        opacity: 0,
        x: 14,
        duration: 0.8,
        ease: "power2.out"
    }, "-=0.4");
}

// Media Hard Right - Image slide in from right
gsap.utils.toArray('.media-hard-right').forEach((section) => {
    const imageContainer = section.querySelector('.hard-right');

    if (imageContainer) {
        gsap.fromTo(imageContainer,
            {
                x: 20
            },
            {
                x: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: section,
                    start: "top bottom-=26%",
                    once: true,
                    //markers: true
                }
            }
        );
    }
});

// Media Hard Left - Image slide in from left
gsap.utils.toArray('.media-hard-left').forEach((section) => {
    const imageContainer = section.querySelector('.hard-left');

    if (imageContainer) {
        gsap.fromTo(imageContainer,
            {
                x: -20
            },
            {
                x: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: section,
                    start: "top bottom-=26%",
                    once: true,
                    //markers: true
                }
            }
        );
    }
});

// Image Grid Overlay Functionality
document.addEventListener('DOMContentLoaded', function() {
    const overlay = document.getElementById('imageOverlay');
    if (!overlay) return; // Exit if overlay doesn't exist
    
    const overlayImg = overlay.querySelector('.overlay-content img');
    const overlayClose = overlay.querySelector('.overlay-close');
    const imageGrids = document.querySelectorAll('.image-grid, .image-grid-rows');
    let currentImages = [];
    let currentIndex = 0;

    // Initialize image grid functionality
    imageGrids.forEach(grid => {
        const images = grid.querySelectorAll('img');
        images.forEach((img, index) => {
            img.addEventListener('click', function(e) {
                e.preventDefault();
                currentImages = Array.from(images);
                currentIndex = index;
                openOverlay(this.src, this.alt);
            });
        });
    });

    // Open overlay function
    function openOverlay(src, alt) {
        overlayImg.src = src;
        overlayImg.alt = alt;
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        
        // Trigger fade in after display is set
        setTimeout(() => {
            overlay.classList.add('visible');
        }, 10);
    }

    // Close overlay function
    function closeOverlay() {
        overlay.classList.remove('visible');
        document.body.style.overflow = '';
        
        // Remove active class after fade out
        setTimeout(() => {
            overlay.classList.remove('active');
            overlayImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
            overlayImg.alt = '';
        }, 300);
    }

    // Navigate to previous/next image
    function navigateImage(direction) {
        if (direction === 'prev') {
            currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
        } else {
            currentIndex = (currentIndex + 1) % currentImages.length;
        }
        const newImage = currentImages[currentIndex];
        overlayImg.src = newImage.src;
        overlayImg.alt = newImage.alt;
    }

    // Event listeners
    overlayClose.addEventListener('click', closeOverlay);
    
    // Click outside to close
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
            closeOverlay();
        }
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
        if (!overlay.classList.contains('active')) return;
        
        switch(e.key) {
            case 'Escape':
                closeOverlay();
                break;
            case 'ArrowLeft':
                navigateImage('prev');
                break;
            case 'ArrowRight':
                navigateImage('next');
                break;
        }
    });
});

// BitDek Theme Selector
document.addEventListener('DOMContentLoaded', function() {
    const themeImage = document.getElementById('bitdek-theme-image');
    if (!themeImage) return;

    const themes = {
        mo: 'Modern Orange',
        nb: 'Nominal Blue',
        cn: 'Cyan Shift',
        cy: 'Neon Wave',
        sn: 'Sunset'
    };

    let currentTheme = 'mo';
    let isDark = false;

    const themeName = document.getElementById('bitdek-theme-name');
    const swatches = document.querySelectorAll('.bitdek-swatch');
    const modeBtn = document.getElementById('bitdek-mode-btn');
    const knob = document.getElementById('bitdek-toggle-indicator');
    const labelLight = document.getElementById('bitdek-label-light');
    const labelDark = document.getElementById('bitdek-label-dark');

    // Preload all theme images for instant switching
    Object.keys(themes).forEach(code => {
        ['light', 'dark'].forEach(mode => {
            const img = new Image();
            img.src = `/assets/imgs/Theme_${code}--${mode}.png`;
        });
    });

    function updatePreview() {
        const mode = isDark ? 'dark' : 'light';
        themeImage.src = `/assets/imgs/Theme_${currentTheme}--${mode}.png`;
        themeImage.alt = `BitDek ${themes[currentTheme]} theme — ${mode} mode`;
        themeName.textContent = themes[currentTheme];
    }

    function updateToggle() {
        if (isDark) {
            knob.classList.add('is-dark');
            labelLight.classList.remove('active');
            labelDark.classList.add('active');
        } else {
            knob.classList.remove('is-dark');
            labelLight.classList.add('active');
            labelDark.classList.remove('active');
        }
    }

    swatches.forEach(swatch => {
        swatch.addEventListener('click', function() {
            currentTheme = this.dataset.theme;
            swatches.forEach(s => s.setAttribute('aria-checked', 'false'));
            this.setAttribute('aria-checked', 'true');
            updatePreview();
        });
    });

    modeBtn.addEventListener('click', function() {
        isDark = !isDark;
        updateToggle();
        updatePreview();
    });

    updatePreview();
});

// Video Overlay Functionality
document.addEventListener('DOMContentLoaded', function() {
    const heroPlayLink = document.getElementById('heroPlay');
    const videoOverlay = document.getElementById('videoOverlay');
    
    if (!heroPlayLink || !videoOverlay) return; // Exit if elements don't exist
    
    const overlayContent = videoOverlay.querySelector('.overlay-content');
    const overlayClose = videoOverlay.querySelector('.overlay-close');
    
    // Vimeo video configuration
    const vimeoVideoId = '1038704777';
    const vimeoParams = 'autoplay=1&muted=1&loop=1&autopause=0&badge=0&app_id=58479';
    
    // Open video overlay
    function openVideoOverlay(e) {
        e.preventDefault();
        
        // Create iframe element with Vimeo's exact structure and caption
        const videoHTML = `
            <div class="video-container">
                <div style="padding:216.53% 0 0 0;position:relative;">
                    <iframe src="https://player.vimeo.com/video/${vimeoVideoId}?${vimeoParams}" 
                            frameborder="0" 
                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
                            style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                            title="Hero Slider Video">
                    </iframe>
                </div>
            </div>
            <div class="video-description">
                <p>Browsing a video platform app should be a joyful experience. To enhance the playful feel, I created a Finto prototype to explore parallax animation in a hero slider.</p>
            </div>
        `;
        
        overlayContent.innerHTML = videoHTML;
        
        // Show overlay
        videoOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        
        // Trigger fade in
        setTimeout(() => {
            videoOverlay.classList.add('visible');
        }, 10);
    }
    
    // Close video overlay
    function closeVideoOverlay() {
        videoOverlay.classList.remove('visible');
        document.body.style.overflow = '';
        
        // Remove iframe and clean up after fade out
        setTimeout(() => {
            videoOverlay.classList.remove('active');
            overlayContent.innerHTML = '';
        }, 300);
    }
    
    // Event listeners
    heroPlayLink.addEventListener('click', openVideoOverlay);
    overlayClose.addEventListener('click', closeVideoOverlay);
    
    // Click outside to close
    videoOverlay.addEventListener('click', function(e) {
        if (e.target === videoOverlay) {
            closeVideoOverlay();
        }
    });
    
    // Escape key to close
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && videoOverlay.classList.contains('active')) {
            closeVideoOverlay();
        }
    });
});
